export default function t(string?: string) {
  if (!string) {
    return "";
  }
  return translations[string] ?? string;
}

const translations: Record<string, string> = {
  AccessPanel: "Revisionsöffnungen",
  actions: "Aktionen",
  ACTIVE: "aktiv",
  actuallyTreated: "Tatsächlich behandelt",
  AerosolSeparator: "Aerosolabscheider",
  AirHandlingUnit: "RLT-Anlage",
  AirHandlingUnitSchwerpunkt: "RLT-Anlage Schwerpunktreinigung",
  AirHandlingUnitSystem: "RLT-Anlage System",
  AirHandlingUnits: "RLT-Anlagen",
  airMicrobial: "Luftkeimprobe",
  AluminiumMeshGreaseFilter: "Alugestrick-Fettfilter",
  after: "Nachher",
  attachment: "Anhang",
  Anemostat: "Anemostat",
  archived: "Archiviert",
  AwayAirDuctAngular: "Fortluftleitung eckig",
  AwayAirDuctRound: "Fortluftleitung rund",
  basePrice: "Grundpreis",
  before: "Vorher",
  billingContact: "Kontakt Rechnungen",
  buildUp: "Verschmutzung",
  BuildUp: "Verschmutzung",
  BranchManager: "Niederlassungsleiter",
  "certificate.Certificate": "Zertifikat",
  cancelled: "Storniert",
  cleanTime: "Zeit",
  Closed: "Geschlossen",
  caso: "Caso",
  Caso: "Caso",
  calculation: "Kalkulation",
  calculations: "Kalkulationen",
  certificate: "Zertifikat",
  certificates: "Zertifikate",
  comment: "Kommentar",
  commitments: "Sollstellungen",
  completed: "Erledigt",
  Completed: "Erledigt",
  componentKind: "Komponente",
  componentData: "Basisdaten",
  "confirmation.Confirmation": "Auftragsbestätigung",
  confirmation: "Auftragsbestätigung",
  confirmations: "Auftragsbestätigungen",
  Construction: "Bauart",
  contact: "Ansprechpartner",
  contract: "Vertrag",
  contracts: "Verträge",
  contractContact: "Kontakt Vertrag",
  contractPrice: "Vertragspreis",
  "count * value": "Anzahl * Wert",
  CoolingCoil: "Kühler",
  CrossFlowHeatExchanger: "Kreuzstromwärmetauscher",
  cycle: "Turnus",
  cycleDiscount: "Turnusrabatt",
  Director: "Geschäftsführer",
  delivery: "Nur Erfüllung",
  DEPRECATED: "veraltet",
  documentation: "Dokumentation",
  download: "Heruntergeladen",
  done: "Beendet",
  draft: "Entwurf",
  DRAFT: "Entwurf",
  DropletEliminator: "Tropfenabscheider",
  Ductwork: "Abluftleitungen",
  DummyPlate: "Blindblech",
  dustDensity: "Staubdichtemessung",
  "dynamics.dynamicssales.opportunity": "Verkaufschance",
  execution: "Ausführung",
  executed: "Ausgeführt",
  email: "E-Mail",
  ExhaustDuct: "Abluftleitung",
  ExhaustDuctAngular: "Abluftleitung eckig",
  ExhaustDuctRound: "Abluftleitung rund",
  ExhaustHood: "Dunstabzugshaube",
  ExhaustHoodSystem: "DAH System",
  ExhaustHoods: "Dunstabzugshauben",
  ExtraHours: "Zusatzarbeiten",
  failed: "Nicht bestanden",
  Fan: "Ventilator",
  Fatty: "Fettig",
  fax: "Fax",
  FilterSection: "Filterkammer",
  finalPrice: "Endpreis",
  FireDamper: "Feuerschutzklappe",
  formula: "Formel",
  FreeText: "Freitext",
  fulfilled: "Erfüllt",
  full: "Vollständig",
  "gsm.htz.confirmation": "HTZ Auftragsbestätigung",
  "gsm.htz.offer": "HTZ Angebot",
  "gsm.htz.order": "HTZ Auftragseingang",
  "gsm.htz.workorder": "HTZ Arbeitsschein",
  "gsm.htz.workorderposition": "HTZ Arbeitsschein-Position",
  "h / 30m²": "Std / 30m²",
  "h / m": "Std / m",
  "h / m²": "Std / m²",
  "h / piece": "Std / Stück",
  HeatingCoil: "Erhitzer",
  Heydal: "Heydal",
  HoodCanopy: "Haube",
  lastminuteriskanalysis: "Gefährdungsbeurteilung",
  "lmra: last minute risk assessment is not completed":
    "Gefährdungsbeurteilung nicht abgeschlossen",
  "length * value": "Länge * Wert",
  "length * width * value": "Länge * Breite * Wert",
  "((length * width) / 30) * value": "((Länge * Breite) / 30) * Wert",
  Lighting: "Beleuchtungskörper",
  malt: "Malz",
  Malt: "Malz",
  "min / piece": "min / Stück",
  "min / m": "min / m",
  "min / m²": "min / m²",
  "min / 30m²": "min / 30m²",
  None: "Keine",
  not_fulfilled: "Nicht erfüllt",
  Oily: "Ölig",
  offer: "Angebot",
  offers: "Angebote",
  offerContact: "Kontakt Angebot",
  totalPrice: "Angebot",
  "offer.Offer": "Angebot",
  Open: "Offen",
  order: "Auftragseingang",
  orders: "Auftragseingänge",
  OutdoorAirDamper: "Außenluftklappe",
  OutdoorAirDuctAngular: "Außenluftleitung eckig",
  OutdoorAirDuctRound: "Außenluftleitung rund",
  Overnight: "Übernacht",
  overview: "Übersicht",
  partially_executed: "Teilweise ausgeführt",
  partially_fulfilled: "Teilweise erfüllt",
  passed: "Bestanden",
  PassiveArea: "Passivfläche",
  Pending: "Ausstehend",
  PerDiem: "Tagesspesen",
  phone: "Telefon",
  planning: "Planung",
  planned: "Geplant",
  position: "Pos",
  post: "Post",
  primaryContact: "Hauptansprechpartner",
  Processing: "In Bearbeitung",
  RecirculatingSprayHumidifier: "Umlaufsprühbefeuchter",
  RecirculationAirDamper: "Umluftklappe",
  RotaryHeatExchanger: "Rotationswärmetauscher",
  report: "Bericht",
  reports: "Berichte",
  representation: "Darstellung",
  Resinous: "Verharzt",
  running: "In Bearbeitung",
  serviceContact: "Kontakt Service",
  skipped: "Ausgelassen",
  specialDiscount: "Sonderrabatt",
  SoundAttenuator: "Schalldämpfer",
  SplitUnit: "Splitgerät",
  summaryreport: "Inspektionsbericht",
  SupplyDuct: "Zuluftleitung",
  SupplyDuctAngular: "Zuluftleitung eckig",
  SupplyDuctRound: "Zuluftleitung rund",
  surfaceMicrobial: "Oberflächenkeimprobe",
  treatment: "Behandlung",
  treatments: "Behandlungen",
  tipCommission: "Tippprovision",
  VBSConfirmationContact: "Kontakt VBS Auftragsbestätigung",
  VBSOfferContact: "Kontakt VBS Angebot",
  VBSWorkOrderContact: "Kontakt VBS Arbeitsschein",
  VentilatedCeiling: "Abluftdecke",
  VentilatedCeilingSystem: "Abluftdecke System",
  VentilatedCeilings: "Abluftdecken",
  water: "Wasserprobe",
  "workorder.WorkOrder": "Arbeitsschein",
  workorder: "Arbeitsschein",
  workorders: "Arbeitsscheine",
  "work-orders": "Arbeitsscheine",
};
